import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { IconFigmaAlertTriangle, IconFigmaArrowLeft, IconFigmaArrowRight } from '@/assets/icons';
import { InfoBanner } from '@/components/common';
import { AuthCard } from '@/features/auth/components/AuthCard';
import { brandTextStyle } from '@/features/auth/components/authFieldStyles';

interface InvalidLinkCardProps {
  title: string;
  message: string;
  retryLabel: string;
  retryTo?: string;
  hint?: string;
  backTo: string;
}

export const InvalidLinkCard = ({
  title,
  message,
  retryLabel,
  retryTo,
  hint,
  backTo
}: InvalidLinkCardProps) => {
  const { t } = useTranslation();

  return (
    <AuthCard px={32} py={36} w={{ base: '100%', md: 440 }}>
      <Stack align="center" gap={14}>
        <Center
          w={56}
          h={56}
          style={{
            borderRadius: 12,
            backgroundColor: 'var(--color-status-danger-soft)',
            color: 'var(--color-status-danger)'
          }}
        >
          <IconFigmaAlertTriangle size={24} />
        </Center>
        <Title order={2} fz={24} fw={700} ta="center" style={brandTextStyle}>
          {title}
        </Title>
        <Text size="sm" ta="center" style={{ color: 'var(--color-text-secondary)' }}>
          {message}
        </Text>

        {hint && <InfoBanner message={hint} />}

        {retryTo ? (
          <Button
            component={Link}
            to={retryTo}
            fullWidth
            rightSection={<IconFigmaArrowRight size={15} />}
          >
            {retryLabel}
          </Button>
        ) : (
          <Button fullWidth rightSection={<IconFigmaArrowRight size={15} />}>
            {retryLabel}
          </Button>
        )}
        <Button
          component={Link}
          to={backTo}
          fullWidth
          variant="outline"
          leftSection={<IconFigmaArrowLeft size={15} />}
        >
          {t('forgotPassword.backToLoginButton')}
        </Button>
      </Stack>
    </AuthCard>
  );
};
